
export function durationFromMs(durationMS) {
    const hourMS = 3600000.0;

    const seconds = Math.floor(durationMS / 1000 % 60.0);
    const minutes = Math.floor((durationMS % hourMS) / 60000.0);

    let hourstr = "";
    if (durationMS > hourMS) {
        const hours = Math.floor(durationMS / hourMS);
        hourstr = hours + ":";
    }
    return hourstr + String(minutes).padStart(2, "0") + ":" + String(seconds).padStart(2, "0") + "";
}

export function filterNameConcat(event, nameconcat) {
    const reV = new RegExp(" v$");
    let queryparts = event.query.toLowerCase().
    replaceAll("'", "").
    replaceAll("′", "").
    replaceAll("’", "").
    replace(new RegExp("^v "), "vtae ").
    replace(new RegExp("^v$"), "vtae").
    replace(" v ", " vtae ").
    replace(new RegExp(" v$"), " vtae").split(" ")

    let tobequeried = nameconcat.replaceAll("RM -", "RM Namjoon namu joonie rapmon").
    replaceAll("JIN -", "jin seokjin").
    replaceAll("j-hope -", "j-hope Hobi hoseok").
    replaceAll("SUGA -", "suga agust d august").
    replaceAll("Agust D -", "suga agust d agustd august").
    replaceAll("Jimin -", "jimin jm").
    replaceAll("V -", "vtae tete teahyung").
    replaceAll("Jung Kook -", "Jung Kook JK Kookie").
    toLowerCase().
    replaceAll("'", "").
    replaceAll("′", "").
    replaceAll("’", "")

    let keepit = true
    for (let i = 0; i < queryparts.length && keepit; i++) {
        keepit = keepit && (tobequeried.search(queryparts[i]) !== -1)
    }

    return keepit;
}

export function setRowNrToPlaylist(playlist, startId = 0) {
    let _playlist = [...playlist];
    for(let i = 0; i < playlist.length; i++) {
        _playlist[i]["plelementid"] = startId+i;
    }
    return _playlist;
}

export function playlistTime (playlist){
    let durationMS = playlist.reduce((partialSum, a) => partialSum + a.duration_ms, 0)

    return durationFromMs(durationMS);
}

export function getSongAlternativesByISRC(allsongs, isrc){
    return allsongs.filter(song => song.isrc === isrc);
}

export function playlistChecker(playlist){
    let minDist = 2;
}

export function groupSongsByISRC(playlist){
    let _playlist = [...playlist]; // create a copy just in case
    let occ = {}
    // nr occurences
    for(let i = 0; i < _playlist.length; i++){
        let isrc = _playlist[i].isrc
        if( isrc in occ){
            occ[isrc] = occ[isrc] + 1;
        } else {
            occ[isrc] = 1;
        }
    }
    return occ;
}

export function getDistancesBetweenSongs(playlist){
    let _playlist = [...playlist]; // create a copy just in case
    //let occ = groupSongsByISRC(playlist);
    let lastOcc = {}
    let deltas = {}
    let alldeltas =[]
    for(let i = 0; i < _playlist.length; i++){
        let isrc = _playlist[i].isrc
        if( isrc in lastOcc){
            let delta = (i - lastOcc[isrc] - 1); // i count the distance as songs inbetween
            if(isrc in deltas){
                deltas[isrc].push(delta);
            }
            else {
                deltas[isrc] = [delta];
            }
            alldeltas.push(delta);
            lastOcc[isrc] = i;
        } else {
            lastOcc[isrc] = i;
        }
    }
    return {deltasByISRC: deltas,
        allDeltas: alldeltas};
}

export function getShuffled(arr) {
    let _arr = [...arr]; // clone it, as we will manipulate the array
    _arr.sort( () => Math.random()-0.5 );
    return _arr;
}